<div class="link-filter">
  <ftr-empty-state
    illustration="warning-line"
    [inline]="true"
    displayTitle="Leaving FTR Justice Cloud"
    [messageTemplate]="message"
  >
    <ng-template #message>
      You are leaving FTR Justice Cloud to go to an external website.
      <br />
      Make sure you trust
      <strong
        ><a [href]="parsedUrl()?.href" rel="noopener noreferrer">{{ parsedUrl() }}</a></strong
      >
      before you continue.
    </ng-template>
  </ftr-empty-state>
  <div class="link-filter__buttons">
    <a ftrButton color="primary" rel="noopener noreferrer" [href]="parsedUrl()?.href" [disabled]="!parsedUrl()"
      >Continue</a
    >
    <button ftrButton color="primary" displayType="inline-text" (click)="cancel()">Cancel</button>
  </div>
</div>
